module.exports = __webpack_public_path__ + "media/images/1-7aa94a6c4618058703a2a24f3b707be9.jpg";